export default "__VITE_ASSET__CcYGa49b__"